<main id="main-heading" tabindex="0" class="container-fluid d-flex" role="main">
  <div class="col-sm-11 mx-auto d-flex flex-column main-heading-div">
    <div [@fadeInOut] class="row pt-3" role="region" aria-label="grid region">
      <h1 class="ps-3">Manage Submission Items</h1>
      <div class="mt-3">
        <nav ngbNav #tabset="ngbNav" [(activeId)]="activeTab" (navChange)="tabChanged($event)" class="nav-tabs" id="manageSubmissionItemsTabset">
          <ng-container ngbNavItem="deviceRegistrationTab"
            *ngIf="dataScope.toLowerCase() === dataScopeEnum.CHINA.toLowerCase() || dataScope.toLowerCase() === dataScopeEnum.SKOREA.toLowerCase() || dataScope.toLowerCase() === dataScopeEnum.US.toLowerCase() || dataScope.toLowerCase() === dataScopeEnum.SA.toLowerCase() || dataScope.toLowerCase() === dataScopeEnum.AU.toLowerCase() || dataScope.toLowerCase() === dataScopeEnum.BRAZIL.toLowerCase() || dataScope.toLowerCase() === dataScopeEnum.SWISSDAMED.toLowerCase()">
            <a ngbNavLink role="tab" tabindex="0">
              <span>Device Registration ({{deviceRegistrationCount}})</span>
            </a>
            <ng-template ngbNavContent>

              <div class="row">
                <div class="col-sm-12  d-flex my-2">
                  <div class="col-sm-2">
                    <span>Results Returned:<span class="badge  warning-background badge-bottom-margin  mx-1"
                        *ngIf="deviceCount >= 0; else emptyBadge">
                        {{deviceCount}}</span>records</span>
                  </div>
                  <div class="col-sm-10">
                    <ejs-checkbox (change)="selectAll($event)" label="Select All" [(checked)]="selectAllChecked"
                      *ngIf="deviceCount > 0">
                    </ejs-checkbox>
                    <span *ngIf="getSelectedItemsCount() > 0" class="ps-3 text-primary">Selected<span
                        class="badge mx-1">
                        {{getSelectedItemsCount()}}</span>records</span>
                  </div>
                </div>
                <ng-template #emptyBadge>
                  <span class="badge warning-background badge-bottom-margin loading-dots mx-1">
                    <span>.</span><span>.</span><span>.</span>
                  </span>
                </ng-template>
              </div>
              <ejs-tooltip #tooltipObj id="tooltipObj" (beforeRender)="tooltipValue($event)" [enableHtmlParse]="false"
                target=".e-ellipsistooltip">
                <ejs-grid #grid [dataSource]="data" allowPaging="true" class="grid-striped" pageSizes="true | []"
                  [pageSettings]="pageOptions" [filterSettings]="filterSettings" [showColumnChooser]="true"
                  [toolbar]="toolbar" (toolbarClick)="toolbarClick($event)" allowSorting="true" allowFiltering="true"
                  allowScrolling="true" [allowReordering]="true" (dataStateChange)="dataStateChange($event)"
                  (actionComplete)="complete($event)" (actionBegin)="actionBegin($event)"
                  (dataBound)="dataBound($event)" (created)="created($event)" (actionFailure)="failure($event)"
                  (load)="load()" (beforeOpenColumnChooser)="checkboxClick($event)" [allowSelection]="true"
                  [selectionSettings]="selectionOptions" (rowDeselected)="rowDeselected($event, 'submissionId')"
                  (rowSelected)="rowSelected($event, 'submissionId')" height="550" [sortSettings]='sortSettings'>

                  <e-columns>
                    <e-column field='select' type='checkbox' width='40' [allowFiltering]="false"
                              [showInColumnChooser]='false' [visible]='true' class='no-border'>
                    </e-column>
                    <e-column type='string' field='deviceIdentifier' headerText='Item DI' width='200'
                              isPrimaryKey='true' clipMode='EllipsisWithTooltip'>
                      <ng-template #template let-data>
                        <a href="javascript:void(0)" (click)='itemClicked("device", data)'>
                          {{data["deviceIdentifier"]}}
                        </a>
                      </ng-template>
                    </e-column>
                    <e-column type='string' field='modelIdentifier' headerText='Basic UDI-DI' width='200'
                              clipMode='EllipsisWithTooltip'
                              [visible]="dataScope.toLowerCase() === dataScopeEnum.SWISSDAMED.toLowerCase()">
                      <ng-template #template let-data>
                        <a href="javascript:void(0)" (click)='itemClicked("model", data)'>
                          {{data["modelIdentifier"]}}
                        </a>
                      </ng-template>
                    </e-column>
                    <e-column type='string' field='applicableLegislation' headerText='Applicable Legislation' width='220'
                              clipMode='EllipsisWithTooltip'
                              [visible]="dataScope.toLowerCase() === dataScopeEnum.SWISSDAMED.toLowerCase()">
                    </e-column>
                    <e-column type='string' field='itemChrn' headerText='MFR CHRN or SPP CHRN' width='220'
                              clipMode='EllipsisWithTooltip'
                              [visible]="dataScope.toLowerCase() === dataScopeEnum.SWISSDAMED.toLowerCase()">
                    </e-column>
                    <e-column type='string' field='itemSrn' headerText='MFR SRN or SPP SRN' width='250'
                              clipMode='EllipsisWithTooltip'
                              [visible]="dataScope.toLowerCase() === dataScopeEnum.SWISSDAMED.toLowerCase()">
                    </e-column>
                    <e-column type='string' field='authorizedRepChrn' headerText='Authorized Representative CHRN' width='280'
                              clipMode='EllipsisWithTooltip'
                              [visible]="dataScope.toLowerCase() === dataScopeEnum.SWISSDAMED.toLowerCase()">
                    </e-column>
                    <e-column type='string' field='riskClass' headerText='Risk Class' width='130'
                              clipMode='EllipsisWithTooltip'
                              [visible]="dataScope.toLowerCase() === dataScopeEnum.SWISSDAMED.toLowerCase()">
                    </e-column>
                    <e-column type='string' field='deviceModel' headerText='Device Model' width='150'
                              isPrimaryKey='true' clipMode='EllipsisWithTooltip'
                              [visible]="dataScope.toLowerCase() === dataScopeEnum.SWISSDAMED.toLowerCase()">
                    </e-column>
                    <e-column type='string' field='sponsorId' headerText='Sponsor ID' width='150'
                              clipMode='EllipsisWithTooltip'
                              [visible]="dataScope.toLowerCase() === dataScopeEnum.AU.toLowerCase()">
                    </e-column>
                    <e-column type='string' field='labelerDuns' headerText='Labeler DUNS Number' width='220'
                              clipMode='EllipsisWithTooltip'
                              [visible]="dataScope.toLowerCase() === dataScopeEnum.US.toLowerCase() || dataScope.toLowerCase() === dataScopeEnum.BRAZIL.toLowerCase()">
                    </e-column>
                    <e-column type='string' field='brandName' 
                              [headerText]="dataScope.toLowerCase() === dataScopeEnum.AU.toLowerCase() ? 'Trade Name(s)' : 'Brand/Trade Name'" 
                              width='220'
                              clipMode='EllipsisWithTooltip'
                              [visible]="dataScope.toLowerCase() === dataScopeEnum.US.toLowerCase() || dataScope.toLowerCase() === dataScopeEnum.BRAZIL.toLowerCase() || dataScope.toLowerCase() === dataScopeEnum.AU.toLowerCase() || dataScope.toLowerCase() === dataScopeEnum.SWISSDAMED.toLowerCase()">
                    </e-column>
                    <e-column type='string' field='deviceClass' headerText='Device Class' width='150'
                              clipMode='EllipsisWithTooltip'
                              [visible]="dataScope.toLowerCase() === dataScopeEnum.AU.toLowerCase()">
                    </e-column>

                    <e-column type='string' field='artgIds' headerText='ARTG ID(s)' width='180'
                              clipMode='EllipsisWithTooltip'
                              [visible]="dataScope.toLowerCase() === dataScopeEnum.AU.toLowerCase()">
                    </e-column>
                    <e-column type='string' field='gmdnCodes' headerText='GMDN Code(s)' width='180'
                              clipMode='EllipsisWithTooltip'
                              [visible]="dataScope.toLowerCase() === dataScopeEnum.US.toLowerCase() || dataScope.toLowerCase() === dataScopeEnum.AU.toLowerCase() || dataScope.toLowerCase() === dataScopeEnum.BRAZIL.toLowerCase()">
                    </e-column>
                    <e-column type='string' field='versionOrModel' headerText='Version or Model' width='180'
                              clipMode='EllipsisWithTooltip'
                              [visible]="dataScope.toLowerCase() !== dataScopeEnum.SWISSDAMED.toLowerCase()">
                    </e-column>
                    <e-column type='string' field='referenceOrCatalogNumber' headerText='Catalog or Reference Number' width='220'
                              clipMode='EllipsisWithTooltip'
                              [visible]="dataScope.toLowerCase() === dataScopeEnum.AU.toLowerCase()">
                    </e-column>
                    <e-column type='string' field='manufacturerId' headerText='Manufacturer ID' width='180'
                              clipMode='EllipsisWithTooltip'
                              [visible]="dataScope.toLowerCase() === dataScopeEnum.AU.toLowerCase()">
                    </e-column>

                    <e-column type='string' field='fdaProductCodes' headerText='FDA Product Code(s)' width='220'
                              clipMode='EllipsisWithTooltip'
                              [visible]="dataScope.toLowerCase() === dataScopeEnum.US.toLowerCase() || dataScope.toLowerCase() === dataScopeEnum.BRAZIL.toLowerCase()">
                    </e-column>

                    <e-column type='string' field='unifiedSocialCreditCode' headerText='Unified Social Credit Code'
                              width='240' clipMode='EllipsisWithTooltip'
                              [visible]="dataScope.toLowerCase() === dataScopeEnum.CHINA.toLowerCase()">
                    </e-column>
                    <e-column type='string' field='classificationCode' headerText='NMPA Classification Code' width='240'
                              clipMode='EllipsisWithTooltip'
                              [visible]="dataScope.toLowerCase() === dataScopeEnum.CHINA.toLowerCase()">
                    </e-column>
                    <e-column type='string' field='productGenericNames' headerText='Product Name/Generic Name'
                              width='270' clipMode='EllipsisWithTooltip'
                              [visible]="dataScope.toLowerCase() === dataScopeEnum.CHINA.toLowerCase()">
                    </e-column>
                    <e-column type='string' field='skuNumber' headerText='Product SKU' width='150'
                              clipMode='EllipsisWithTooltip'>
                    </e-column>

                    <e-column type='string' field='changeUserName' headerText='Created by' width='200'
                              clipMode='EllipsisWithTooltip'>
                    </e-column>
                    <e-column type='date' field='changeDate' headerText='Created Date/Time' width='200'
                              [format]='formatOptions' clipMode='EllipsisWithTooltip'></e-column>

                    <e-column type='string' field='submissionId' headerText='' width='0' [showInColumnChooser]='false'
                              [visible]='false'></e-column>

                    <!--    <e-column type='string' field='submissionStatus' headerText='Submission Status' width='250'
        clipMode='EllipsisWithTooltip'>
        <ng-template #template let-data>
            <span class="tooltip-span"
                (mouseover)="showTooltip($event, 'Submission Status')">{{data["submissionStatus"]}}</span>
        </ng-template>
    </e-column>
  -->


                  </e-columns>
                </ejs-grid>
              </ejs-tooltip>
            </ng-template>

          </ng-container>

          <ng-container ngbNavItem="newBudi" *ngIf="dataScope.toLowerCase() === dataScopeEnum.EUDAMED.toLowerCase()">
            <a ngbNavLink role="tab" tabindex="0">
              <span *ngIf="dataScope.toLowerCase() === dataScopeEnum.EUDAMED.toLowerCase()">New Basic UDI-DI
                Registration ({{modelTabCounter}})</span>
            </a>
            <ng-template ngbNavContent>
              <div class="row">
                <div class="col-sm-12 d-flex my-2">
                  <div class="col-sm-2">
                    <span>Results Returned:<span class="badge  warning-background badge-bottom-margin mx-1"
                        *ngIf="deviceCount >= 0; else emptyBadge">
                        {{deviceCount}}</span>records</span>
                  </div>
                  <div class="col-sm-10">
                    <ejs-checkbox (change)="selectAll($event)" label="Select All" [(checked)]="selectAllChecked"
                      *ngIf="deviceCount > 0">
                    </ejs-checkbox>
                    <span *ngIf="getSelectedItemsCount() > 0" class="ps-3 text-primary">Selected<span
                        class="badge mx-1">
                        {{getSelectedItemsCount()}}</span>records</span>
                  </div>
                </div>
                <ng-template #emptyBadge>
                  <span class="badge  warning-background badge-bottom-margin loading-dots mx-1">
                    <span>.</span><span>.</span><span>.</span>
                  </span>
                </ng-template>
              </div>
              <ejs-tooltip #tooltipObj id="tooltipObj" (beforeRender)="tooltipValue($event)" [enableHtmlParse]="false"
                target=".e-ellipsistooltip">
                <ejs-grid #grid
                  [dataSource]="data | filter : 'submissionTypeCode' : submissionTypeEnum.MdrCreateNewDeviceModel"
                  allowPaging="true" class="grid-striped" pageSizes="true | []" [pageSettings]="pageOptions"
                  [filterSettings]="filterSettings" [showColumnChooser]="true" [toolbar]="toolbar"
                  (toolbarClick)="toolbarClick($event)" allowSorting="true" allowFiltering="true" allowScrolling="true"
                  [allowReordering]="true" (dataStateChange)="dataStateChange($event)"
                  (actionComplete)="complete($event)" (actionBegin)="actionBegin($event)"
                  (dataBound)="dataBound($event)" (created)="created($event)" (actionFailure)="failure($event)"
                  (load)="load()" (beforeOpenColumnChooser)="checkboxClick($event)" [allowSelection]="true"
                  [selectionSettings]="selectionOptions" (rowDeselected)="rowDeselected($event, 'submissionId')"
                  (rowSelected)="rowSelected($event, 'submissionId')" height="550" [sortSettings]='sortSettings'>

                  <e-columns>
                    <e-column field='select' type='checkbox' width='40' [allowFiltering]="false"
                      [showInColumnChooser]='false' [visible]='true' class='no-border'>
                    </e-column>
                    <e-column type='string' field='deviceIdentifier' headerText='Item DI' width='200'
                      isPrimaryKey='true' clipMode='EllipsisWithTooltip'>
                      <ng-template #template let-data>
                        <a href="javascript:void(0)" (click)='itemClicked("device", data)'>
                          {{data["deviceIdentifier"]}}
                        </a>
                      </ng-template>

                    </e-column>
                    <e-column type='string' field='modelIdentifier' headerText='Basic UDI-DI' width='200'
                      clipMode='EllipsisWithTooltip'>
                      <ng-template #template let-data>
                        <a href="javascript:void(0)" (click)='itemClicked("model", data)'>
                          {{data["modelIdentifier"]}}
                        </a>
                      </ng-template>
                    </e-column>
                    <e-column type='string' field='applicableLegislation' headerText='Applicable Legislation'
                      width='220' clipMode='EllipsisWithTooltip'>
                    </e-column>
                    <e-column type='string' field='itemSrn' headerText='MFR SRN or SPP SRN' width='250'
                      [visible]="dataScope.toLowerCase() === dataScopeEnum.EUDAMED.toLowerCase()"
                      [showInColumnChooser]="dataScope.toLowerCase() === dataScopeEnum.EUDAMED.toLowerCase()">
                    </e-column>
                    <e-column type='string' field='riskClass' headerText='Risk Class' width='130'
                      clipMode='EllipsisWithTooltip'>
                    </e-column>
                    <e-column type='string' field='deviceModel' headerText='Device Model' width='150'
                      isPrimaryKey='true' clipMode='EllipsisWithTooltip'>
                    </e-column>
                    <e-column type='string' field='brandName' headerText='Brand/Trade Name' width='190'
                      clipMode='EllipsisWithTooltip'>
                    </e-column>
                    <e-column type='string' field='skuNumber' headerText='Product SKU' width='150'
                      clipMode='EllipsisWithTooltip'>
                    </e-column>

                    <e-column type='string' field='changeUserName' headerText='Created by' width='200'
                      clipMode='EllipsisWithTooltip'>
                    </e-column>
                    <e-column type='date' field='changeDate' headerText='Created Date/Time' width='200'
                      [format]='formatOptions' clipMode='EllipsisWithTooltip'></e-column>

                    <e-column type='string' field='submissionId' headerText='' width='0' [showInColumnChooser]='false'
                      [visible]='false'></e-column>


                  </e-columns>
                </ejs-grid>
              </ejs-tooltip>
            </ng-template>

          </ng-container>
          <ng-container ngbNavItem="newUdi" *ngIf="dataScope.toLowerCase() === dataScopeEnum.EUDAMED.toLowerCase()">
            <a ngbNavLink role="tab" tabindex="0">
              <span>New UDI-DI Registration ({{deviceTabCounterNewUdi}})</span>
            </a>
            <ng-template ngbNavContent>
              <div class="row">
                <div class="col-sm-12 d-flex my-2">
                  <div class="col-sm-2">
                    <span>Results Returned:<span class="badge  warning-background badge-bottom-margin  mx-1"
                        *ngIf="deviceCount >= 0; else emptyBadge">
                        {{deviceCount}}</span>records</span>
                  </div>
                  <div class="col-sm-10">
                    <ejs-checkbox (change)="selectAll($event)" label="Select All" [(checked)]="selectAllChecked"
                      *ngIf="deviceCount > 0">
                    </ejs-checkbox>
                    <span *ngIf="getSelectedItemsCount() > 0" class="ps-3 text-primary">Selected<span
                        class="badge mx-1">
                        {{getSelectedItemsCount()}}</span>records</span>
                  </div>
                </div>
                <ng-template #emptyBadge>
                  <span class="badge  warning-background badge-bottom-margin loading-dots mx-1">
                    <span>.</span><span>.</span><span>.</span>
                  </span>
                </ng-template>
              </div>
              <ejs-tooltip #tooltipObj id="tooltipObj" (beforeRender)="tooltipValue($event)" [enableHtmlParse]="false"
                target=".e-ellipsistooltip">
                <ejs-grid #grid
                  [dataSource]="data | filter : 'submissionTypeCode' : submissionTypeEnum.MdrAddDevicesToRegisteredModel"
                  allowPaging="true" class="grid-striped" pageSizes="true | []" [pageSettings]="pageOptions"
                  [filterSettings]="filterSettings" [showColumnChooser]="true" [toolbar]="toolbar"
                  (toolbarClick)="toolbarClick($event)" allowSorting="true" allowFiltering="true" allowScrolling="true"
                  [allowReordering]="true" (dataStateChange)="dataStateChange($event)"
                  (actionComplete)="complete($event)" (actionBegin)="actionBegin($event)"
                  (dataBound)="dataBound($event)" (created)="created($event)" (actionFailure)="failure($event)"
                  (load)="load()" (beforeOpenColumnChooser)="checkboxClick($event)" [allowSelection]="true"
                  [selectionSettings]="selectionOptions" (rowDeselected)="rowDeselected($event, 'submissionId')"
                  (rowSelected)="rowSelected($event, 'submissionId')" height="550" [sortSettings]='sortSettings'>

                  <e-columns>
                    <e-column field='select' type='checkbox' width='40' [allowFiltering]="false"
                      [showInColumnChooser]='false' [visible]='true' class='no-border'>
                    </e-column>
                    <e-column type='string' field='deviceIdentifier' headerText='Item DI' width='200'
                      isPrimaryKey='true' clipMode='EllipsisWithTooltip'>
                      <ng-template #template let-data>
                        <a href="javascript:void(0)" (click)='itemClicked("device", data)'>
                          {{data["deviceIdentifier"]}}
                        </a>
                      </ng-template>

                    </e-column>
                    <e-column type='string' field='modelIdentifier' headerText='Basic UDI-DI' width='200'
                      clipMode='EllipsisWithTooltip'>
                      <ng-template #template let-data>
                        <a href="javascript:void(0)" (click)='itemClicked("model", data)'>
                          {{data["modelIdentifier"]}}
                        </a>
                      </ng-template>
                    </e-column>
                    <e-column type='string' field='applicableLegislation' headerText='Applicable Legislation'
                      width='220' clipMode='EllipsisWithTooltip'>
                    </e-column>
                    <e-column type='string' field='itemSrn' headerText='MFR SRN or SPP SRN' width='250'
                      [visible]="dataScope.toLowerCase() === dataScopeEnum.EUDAMED.toLowerCase()"
                      [showInColumnChooser]="dataScope.toLowerCase() === dataScopeEnum.EUDAMED.toLowerCase()">
                    </e-column>
                    <e-column type='string' field='riskClass' headerText='Risk Class' width='130'
                      clipMode='EllipsisWithTooltip'>
                    </e-column>
                    <e-column type='string' field='deviceModel' headerText='Device Model' width='150'
                      isPrimaryKey='true' clipMode='EllipsisWithTooltip'>
                    </e-column>
                    <e-column type='string' field='brandName' headerText='Brand/Trade Name' width='190'
                      clipMode='EllipsisWithTooltip'>
                    </e-column>
                    <e-column type='string' field='skuNumber' headerText='Product SKU' width='150'
                      clipMode='EllipsisWithTooltip'>
                    </e-column>

                    <e-column type='string' field='changeUserName' headerText='Created by' width='200'
                      clipMode='EllipsisWithTooltip'>
                    </e-column>
                    <e-column type='date' field='changeDate' headerText='Created Date/Time' width='200'
                      [format]='formatOptions' clipMode='EllipsisWithTooltip'></e-column>

                    <e-column type='string' field='submissionId' headerText='' width='0' [showInColumnChooser]='false'
                      [visible]='false'></e-column>


                  </e-columns>
                </ejs-grid>
              </ejs-tooltip>
            </ng-template>
          </ng-container>
          <ng-container ngbNavItem="changes" *ngIf="dataScope.toLowerCase() === dataScopeEnum.EUDAMED.toLowerCase()">
            <a ngbNavLink role="tab" tabindex="0">
              <span>Changes to Previous Registrations ({{deviceTabCounterChanges}})</span>
            </a>
            <ng-template ngbNavContent>
              <div class="row">
                <div class="col-sm-12 d-flex my-2">
                  <div class="col-sm-2">
                    <span>Results Returned:<span class="badge  warning-background badge-bottom-margin  mx-1"
                        *ngIf="deviceCount >= 0; else emptyBadge">
                        {{deviceCount}}</span>records</span>
                  </div>
                  <div class="col-sm-10">
                    <ejs-checkbox (change)="selectAll($event)" label="Select All" [(checked)]="selectAllChecked"
                      *ngIf="deviceCount > 0">
                    </ejs-checkbox>
                    <span *ngIf="getSelectedItemsCount() > 0" class="ps-3 text-primary">Selected<span
                        class="badge mx-1">
                        {{getSelectedItemsCount()}}</span>records</span>
                  </div>
                </div>
                <ng-template #emptyBadge>
                  <span class="badge  warning-background badge-bottom-margin loading-dots mx-1">
                    <span>.</span><span>.</span><span>.</span>
                  </span>
                </ng-template>
              </div>
              <ejs-tooltip #tooltipObj id="tooltipObj" (beforeRender)="tooltipValue($event)" [enableHtmlParse]="false"
                target=".e-ellipsistooltip">
                <!-- currently displaying status 4 MDR - Update Model, later the status 3 MDR - Update Device will be added-->
                <ejs-grid #grid
                  [dataSource]="data | filter : 'submissionTypeCode' : [submissionTypeEnum.MdrUpdateDevice, submissionTypeEnum.MdrUpdateModel] "
                  allowPaging="true" class="grid-striped" pageSizes="true | []" [pageSettings]="pageOptions"
                  [filterSettings]="filterSettings" [showColumnChooser]="true" [toolbar]="toolbar"
                  (toolbarClick)="toolbarClick($event)" allowSorting="true" allowFiltering="true" allowScrolling="true"
                  [allowReordering]="true" (dataStateChange)="dataStateChange($event)"
                  (actionComplete)="complete($event)" (actionBegin)="actionBegin($event)"
                  (dataBound)="dataBound($event)" (created)="created($event)" (actionFailure)="failure($event)"
                  (load)="load()" (beforeOpenColumnChooser)="checkboxClick($event)" [allowSelection]="true"
                  [selectionSettings]="selectionOptions" (rowDeselected)="rowDeselected($event, 'submissionId')"
                  (rowSelected)="rowSelected($event, 'submissionId')" height="550" [sortSettings]='sortSettings'>

                  <e-columns>
                    <e-column field='select' type='checkbox' width='40' [allowFiltering]="false"
                      [showInColumnChooser]='false' [visible]='true' class='no-border'>
                    </e-column>
                    <e-column type='string' field='deviceIdentifier' headerText='Item DI' width='200' isPrimaryKey='true'
                              clipMode='EllipsisWithTooltip'>
                      <ng-template #template let-data>
                        <a href="javascript:void(0)" class="pointer" (click)='itemClicked("device",data)'
                           *ngIf="itemSubmissionType(data) === 'device'; else modelTemplate ">
                          {{data["deviceIdentifier"]}}
                        </a>

                        <ng-template #modelTemplate>
                          <a href="javascript:void(0)" class="pointer" (click)='itemClicked("model",data)'>
                            {{data["modelIdentifier"]}}
                          </a>
                        </ng-template>
                      </ng-template>

                    </e-column>

                    <e-column type='string' field='modelIdentifier' headerText='Basic UDI-DI' width='200'
                      clipMode='EllipsisWithTooltip'>
                      <ng-template #template let-data>
                        <a href="javascript:void(0)" (click)='itemClicked("model", data)'>
                          {{data["modelIdentifier"]}}
                        </a>
                      </ng-template>
                    </e-column>
                    <e-column type='string' field='applicableLegislation' headerText='Applicable Legislation'
                      width='220' clipMode='EllipsisWithTooltip'>
                    </e-column>
                    <e-column type='string' field='itemSrn' headerText='MFR SRN or SPP SRN' width='250'
                      [visible]="dataScope.toLowerCase() === dataScopeEnum.EUDAMED.toLowerCase()"
                      [showInColumnChooser]="dataScope.toLowerCase() === dataScopeEnum.EUDAMED.toLowerCase()">
                    </e-column>
                    <e-column type='string' field='riskClass' headerText='Risk Class' width='130'
                      clipMode='EllipsisWithTooltip'>
                    </e-column>
                    <e-column type='string' field='deviceModel' headerText='Device Model' width='150'
                      isPrimaryKey='true' clipMode='EllipsisWithTooltip'>
                    </e-column>
                    <e-column type='string' field='brandName' headerText='Brand/Trade Name' width='190'
                      clipMode='EllipsisWithTooltip'>
                    </e-column>
                    <e-column type='string' field='skuNumber' headerText='Product SKU' width='150'
                      clipMode='EllipsisWithTooltip'>
                    </e-column>

                    <e-column type='string' field='changeUserName' headerText='Created by' width='200'
                      clipMode='EllipsisWithTooltip'>
                    </e-column>
                    <e-column type='date' field='changeDate' headerText='Created Date/Time' width='200'
                      [format]='formatOptions' clipMode='EllipsisWithTooltip'></e-column>

                    <e-column type='string' field='submissionId' headerText='' width='0' [showInColumnChooser]='false'
                      [visible]='false'></e-column>


                  </e-columns>
                </ejs-grid>
              </ejs-tooltip>
            </ng-template>
          </ng-container>
        </nav>
        <div [ngbNavOutlet]="tabset"></div>

      </div>
    </div>
  </div>
</main>

<ejs-dialog #dialog id="dialog" [isModal]='isModal' [animationSettings]='animationSettings' [closeOnEscape]='false'
  [width]='modalWidth' [position]='modalPosition' [visible]='sendModalVisible' [showCloseIcon]='false'
  [height]='modalHeight' [hidden]='!sendModalVisible' oncontextmenu="return false;" (close)='onDialogClose($event)'
  aria-hidden="true">
  <ng-template #content>
    <form #form="ngForm">
      <div class="card">
        <div class="card-header bg-primary text-white">
          <h4 class="card-title">
            E-signature Required
          </h4>
        </div>
        <div class="card-body">
          <h4 class="px-3">{{getSelectedItemsCount()}} Approval(s) will be submitted to
            {{dataScope?.toUpperCase()}}</h4>
          <div class="px-3" aria-label="Esignature confirmation acknowledging">
            <p>By selecting Continue, you are acknowledging that all information is in accordance with the recipient
                 health authority guidelines and approving the submission to the health authority.
            </p>
            <div class="text-danger extra-bottom-margin" [hidden]='eSignatureConfirmed'>{{eSignatureErrorMessage}}
            </div>
          </div>

          <div class="d-flex flex-column">
      
            <div class="card-footer">
              <button id="btnCancel" type="button" class="btn btn-default dialogButton" aria-label="Cancel"
                (click)="eSigCancel($event)">Cancel</button>

              <button id="btnConfirm" type="button" class="btn btn-primary dialogButton"
                [class.disabled]="confirmClicked" aria-label="Confirm"
                (click)="confirmedClicked();"
                (dblclick)="buttonDoubleClick($event)">Confirm</button>
            </div>
          </div>
        </div>
      </div>

    </form>
  </ng-template>
</ejs-dialog>
<ejs-dialog #rejectDialog id="rejectDialog" [isModal]='isModal' [animationSettings]='animationSettings'
  aria-hidden="true" [closeOnEscape]='false' [width]='modalWidth' [position]='modalPosition'
  [visible]='rejectModalVisible' [showCloseIcon]='false' [height]='modalHeight' [hidden]='!rejectModalVisible'
  oncontextmenu="return false;" (close)='onRejectDialogClose($event)'>
  <ng-template #content>
    <form #form="ngForm">
      <div class="card">
        <div class="card-header bg-primary text-white">
          <h4 class="card-title">
            Reject Submission Item(s)
          </h4>
        </div>
        <div class="card-body">
          <div class="px-2 my-2">
            <p aria-label="A note is required for rejecting a submission item(s)">A note is required for rejecting a
              submission item(s).</p>
          </div>
          <div class="px-2 my-2">
            <div class="class='form-group">
              <label id="reject-note" for="txtRejectNote">Note:</label>
              <textarea id='taRejectNote' rows='3' class="form-control" (keyup)="onKeyUp($event)" aria-required="true"
                aria-invalid="true" aria-errormessage="note-required" aria-labelledby="reject-note"></textarea>
              <label id="note-required" *ngIf="rejectionSubmitted && !rejectionNoteProvided" class="text-danger"
                aria-hidden="true">Please provide a Rejection Note.</label>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <button id="btnRejectCancel" type="button" class="btn btn-default dialogButton" (click)="rejectCancel($event)"
            data-ripple="true">Cancel</button>
          <button id="btnRejectSubmit" type="button" class="btn btn-primary dialogButton" data-ripple="true"
            (click)="rejectSubmit()">Submit</button>
        </div>
      </div>
    </form>
  </ng-template>
</ejs-dialog>


<div *ngIf="!gridComplete" class="col-sm-12">
  <div id="loading"></div>
</div>

<ng-template #submittemplate let-data aria-hidden="true">
  <button id="sendtochannel" class='e-tbar-btn e-tbtn-txt e-control e-btn e-lib'
    *appHideByAccess="permissionsConst.CanSubmitData" aria-label="Send to channel">
    <span class='e-btn-icon fas fa-paper-plane e-icons e-icon-left'></span>
    <span class='e-tbar-btn-text' aria-label="Send to health authority">Send to {{
      sentToChannelButtonText(healthAuthority) }}</span>
  </button>
</ng-template>

<ng-template #rejecttemplate let-data aria-hidden="true">
  <button id="rejectselected" class='e-tbar-btn e-tbtn-txt e-control e-btn e-lib'
    *appHideByAccess="permissionsConst.CanRejectData" aria-label="Reject">
    <span class='e-btn-icon fas fa-ban e-icons e-icon-left'></span>
    <span class='e-tbar-btn-text' aria-label="reject">Reject</span>
  </button>
</ng-template>

<ejs-dialog #dblClickDialog id="dblClickDialog" [isModal]='isModal' [animationSettings]='animationSettings'
  [closeOnEscape]='true' aria-hidden="true" [showCloseIcon]='false' [width]='alertWidth' [position]='modalPosition'
  [visible]='dblClickDialogModalVisible' [height]='modalHeight' [hidden]='!dblClickDialogModalVisible'
  (close)='onDblClickDialogClose($event)'>

  <div class="card">
    <div class="card-header bg-primary text-white">
      <h4 class="card-title">Error</h4>
    </div>
    <div class="card-body" aria-invalid="true" aria-errormessage="dbl-click-error">
      <span id="dbl-click-error">The button cannot be double clicked. Please try again.</span>
    </div>
    <div class="card-footer">
      <button id="dblClickClose" class="btn btn-primary dialogButton" (click)="dblClickDialogClose($event)"
        aria-label="ok">OK</button>
    </div>
  </div>
</ejs-dialog>
